import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
import { changePostParam } from '@/util/changePostParam';

const serverUrl = publishObjectPath.serverUrl + '/api/yunnan';
const serverUrl2 = publishObjectPath.serverUrl + '/api';
const qs = require('qs');
const conttype = 'application/x-www-form-urlencoded';

export class SchedulePlan {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 查询不分页数据接口
  public getAllList(opts: object) {
    const url = serverUrl + '/schedule/manage/list';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 查询分页数据接口
  public getList(opts: object) {
    const url = serverUrl + '/schedule/manage/page';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  public get(id: string) {
    const url = serverUrl + `/schedule/manage/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  public add(opts: any) {
    const url = serverUrl + '/schedule/manage';
    return this.rSerivce.serverObj.post(url, opts);
  }

  public edit(id: string, opts: any) {
    const url = serverUrl + `/schedule/manage/${id}`;
    return this.rSerivce.serverObj.put(url, opts);
  }

  public remove(id: string | string[]) {
    if (id instanceof Array) id = id.join(',');
    const url = serverUrl + `/schedule/manage/${id}`;
    return this.rSerivce.serverObj.delete(url);
  }

  public getCalendar(date: string) {
    const url = serverUrl + `/schedule/manage/calendar/${date}`;
    return this.rSerivce.serverObj.get(url);
  }
  public getOrder(id: string | string[]) {
    const url = serverUrl + `/schedule/manage/order/${id}`;
    return this.rSerivce.serverObj.get(url);
  }

  public getStaffList(opts: any) {
    const url = serverUrl2 + `/spaceManage/spaceStaff`;
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  } // 获取人员列表
}
